import React from 'react';
import CommitNumericFieldBase from './commit-numeric-field-base';

interface CommitNumberFieldProps {
  value: number | undefined;
  onCommit: (value: number) => void;
  step?: number;
  min?: number;
  max?: number;
  placeholder?: string;
}

/** Numeric field that always holds a value — clearing it commits nothing. */
const CommitNumberField: React.FC<CommitNumberFieldProps> = (props) => (
  <CommitNumericFieldBase {...props} format={(value) => String(Number(value.toFixed(2)))} />
);

export default CommitNumberField;
